module.exports = __webpack_public_path__ + "images/icons/home-hero.svg";